<div class="btn-group" role="group">
    <div class="btn-group" role="group" ngbDropdown>
        <button
            mat-button
            class="btn btn-secondary btn-dropdown"
            style="
                border: 1px solid #7e94ac;
                background-color: #efefef;
                color: #7e94ac;
                padding-left: 10px;
                padding-right: 10px;
                height: 39px;
                font-size: 15px;
                min-width: 80px;
            "
            ngbDropdownToggle>
            {{ selectedOption?.label }}
        </button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-container">
            <div class="scrollable-dropdown">
                @for (item of filteredOptions; track item) {
                    <button class="dropdown-item" (click)="select(item)">
                        {{ item.label }}
                    </button>
                }
            </div>
        </div>
    </div>
</div>
